import gql from 'graphql-tag';

export const updateViewersQuery = gql`
  mutation UpdateViewers($commentId: String!) {
    updateViewers(commentId: $commentId) {
      commentId
      parentId
      content
      metadata
      isResolved
      updatedAt
      createdByUser {
        userId
        firstName
        lastName
        imageUrl
      }
      children {
        commentId
        parentId
        content
        metadata
        isResolved
        updatedAt
      }
    }
  }
`;

const updateViewers = () => ({
  mutation: updateViewersQuery,
  module: 'comments',
  buildVariables: ({ commentId }) => ({
    commentId
  })
});

export default updateViewers;